<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" data-testid="directions-40" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>{{ pageTitle }}</h1>
                  
                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
            </div>
            <el-form class="full_page" :model="form" ref="userForm" label-position="top">
                <div class="job_row">

                    <div class="job_row--content">
                        <el-form-item class="no-scroll" :required="true" label="Work Type" prop="job_type">
                            <el-select :class="{ 'selected': form.job_type !== '' }" popper-class="normal-select"
                                data-testid="directions-42" v-model="form.job_type" size="large"
                                placeholder="Select Work Type">
                                <el-option v-for="option in jobTypeOptions" :key="option.value" :label="option.label"
                                    :value="option.value" :selected="form.job_type === option.value">
                                    {{ option.label }}
                                </el-option>
                            </el-select>
                        </el-form-item>

                    </div>
                </div>

                <div class="job_row">
                    <div class="job_row--content">
                        <el-form-item class="no-scroll" :required="true" label="Role Type" prop="platform_role_id">
                            <el-select :class="{ 'selected': form.platform_role_id !== '' }" popper-class="normal-select"
                                data-testid="directions-42" v-model="form.platform_role_id" size="large"
                                placeholder="Select Role Type">
                                <el-option v-for="option in platformRoles" :key="option.value" :label="option.label"
                                    :value="option.value" :selected="form.platform_role_id === option.value">
                                    {{ option.label }}
                                </el-option>
                            </el-select>
                        </el-form-item>

                    </div>
                </div>

                <div class="job_row">
                    <div class="job_row--content">
                        <el-form-item :error="v$.job_title.$error" :show-message="false" class="no-scroll"
                            :required="true" label="Job Title" prop="job_title">
                            <el-input data-testid="directions-43" class="job_row--content" v-model="form.job_title"
                                placeholder="Please enter job title" @blur="validateField('job_title')"
                                @input="validateField('job_title')"></el-input>
                            <el-form-item-error v-if="v$.job_title.$error">{{ v$.job_title.$errors[0].$message
                                }}</el-form-item-error>
                        </el-form-item>
                    </div>
                </div>


                <div class="job_row">
                    <el-form-item label="Set Job Location" :error="v$.job_location.$error" :show-message="false"
                        class="no-scroll" prop="job_location" :required="true">
                        <div class="el-input el-input--prefix" :class="form.job_location.disabled ? 'is-disabled' : ''">
                            <vue-google-suburb-autocomplete data-testid="directions-102" id="map"
                                classname="el-input__inner" :ref="(el) => (form.job_location.ref = el)"
                                v-model="form.job_location" placeholder="Select City and State"
                                :initial-location="jobLocationText" :key="addressComponent"
                                v-on:placechanged="setAddressData" :country="countryArray"
                                :disabled="form.job_location.disabled">
                            </vue-google-suburb-autocomplete>
                            <span class="el-input__prefix"><i class="el-input__icon el-icon-search"></i></span>
                        </div>
                    </el-form-item>
                </div>

                <div class="job_row">
                    <el-form-item :error="v$.job_category.$error" :show-message="false" class="no-scroll"
                        :required="true" label="Job Category" prop="job_category">
                        <el-radio-group data-testid="directions-45" class="job-category-select"
                            v-model="form.job_category" @change="validateField('job_category')">
                            <el-radio v-for="option in selectedCategories" :key="option.value" :label="option.value"
                                :selected="form.job_category == option.value">{{
                                    option.label }}</el-radio>
                        </el-radio-group>
                        <el-form-item-error v-if="v$.job_category.$error">{{ v$.job_category.$errors[0].$message
                            }}</el-form-item-error>
                    </el-form-item>
                    <el-button class="outlined see-categories" @click="showDialog($event)">See all
                        categories</el-button>
                </div>


                <div class="job_row">
                    <div class="input_label">Popular Skills</div>
                    <div class="job_row--content">
                        <el-checkbox-group data-testid="directions-47" class="skill-checkbox-select"
                            v-model="selectedPopularSkills">
                            <el-checkbox v-for="item in popularSkillsOptions" :key="item.value" :label="item">

                                {{ item.label }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="job_row">
                    <div class="job_row">
                        <el-form-item class="no-scroll" label="Payment Time" prop="rate_type">
                            <el-select :class="{ 'selected': form.rate_type !== '' }" popper-class="normal-select"
                                v-model="form.rate_type" placeholder="Select Rate Type">
                                <el-option label="Hourly" value="hourly"></el-option>
                                <el-option label="Annual" value="annual"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>

                    <div class="job_row">
                        <el-form-item class="no-scroll">
                            <el-checkbox v-model="form.hide_salary">Hide Salary</el-checkbox>
                        </el-form-item>
                    </div>

                    <div class="job_row">
                        <el-form-item :error="v$.min_rate.$error" :show-message="false" class="no-scroll"
                            label="Minimum Pay Rate" :required="true" prop="min_rate">
                            <div class="input-wrapper">
                                <el-input data-testid="directions-53" v-model="form.min_rate" placeholder="0.00"
                                    @input="validateField('min_rate')">
                                    <template #suffix v-if="isAustralia">
                                        AUD
                                    </template>
                                    <template #suffix v-else>
                                        USD
                                    </template>
                                </el-input>
                            </div>
                            <el-form-item-error v-if="v$.min_rate.$error">{{ v$.min_rate.$errors[0].$message
                                }}</el-form-item-error>
                        </el-form-item>
                    </div>
                    <div class="job_row">
                        <el-form-item :error="v$.max_rate.$error" :show-message="false" class="no-scroll"
                            label="Maximum Pay Rate" :required="true" prop="max_rate">
                            <div class="input-wrapper">
                                <el-input data-testid="directions-54" v-model="form.max_rate" placeholder="0.00"
                                   @input="validateField('max_rate')">
                                    <template #suffix v-if="isAustralia">
                                        AUD
                                    </template>
                                    <template #suffix v-else>
                                        USD
                                    </template>
                                </el-input>
                            </div>
                            <el-form-item-error v-if="v$.max_rate.$error">{{ v$.max_rate.$errors[0].$message
                                }}</el-form-item-error>
                        </el-form-item>
                    </div>

                    <div class="job_row">
                        <el-form-item :required="true" label=" Is a bonus or commission offered for this position?">
                            <el-radio-group v-model="form.bonus">
                                <el-radio label="Yes" size="large" :selected="form.bonus === 'Yes'">Yes</el-radio>
                                <el-radio label="No" size="large" :selected="form.bonus === 'No'">No</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </div>


                <el-form-item class="button_submit mb0">
                    <el-button @click="goNext()" :disabled="isSubmitDisabled" class="submit">
                        <span>Continue</span>
                    </el-button>
                </el-form-item>

            </el-form>
            <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
            </div>
            <el-drawer class="job-category-dialog" v-model="dialogVisible" title="Job Categories" :direction="'btt'" :before-close="handleBeforeClose">
                <el-radio-group data-testid="directions-48" v-model="form.job_category" @change="handleSelectionChange"
                    class="job-category-select">
                    <el-radio v-for="option in getCategories" :key="option.value" :label="option.value">{{ option.label
                        }}</el-radio>
                </el-radio-group>
                <el-button type="primary" @click="selectCategory(option)">Confirm</el-button>
            </el-drawer>
        </div>
    </div>
</template>


<script>
import { reactive, computed, inject, onMounted, ref, onBeforeMount, watch,getCurrentInstance } from 'vue';
import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useRouter,
} from 'vue-router'
import { useVuelidate } from '@vuelidate/core';
import { required, helpers, maxLength } from '@vuelidate/validators';
import { useStore } from "vuex";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import { VueGoogleSuburbAutocomplete } from "@/components/components";
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        VueGoogleSuburbAutocomplete,
        SvgIcon
    },
    directives: {

    },

    setup() {
        const $router = useRouter()
        const setPageClassGlobal = inject(['setPageClassGlobal']);
        const $store = useStore();
        const jobListingCreatePageData = $store.getters.getJobListingCreatePageData;
        const isAustralia = isAustraliaRegion();
        const jobLocationText = ref('');
        const addressComponent = ref(0);
        const user = $store.getters.GET_USER_DATA;
        const instance = getCurrentInstance();
        const backPage = $store.getters.getLastPage;
        console.log("🚀 ~ setup ~ jobListingCreatePageData:", jobListingCreatePageData)
        const pageTitle = computed(() => {
            return jobListingCreatePageData.is_republish ? 'Republish Job Ad' : 'Create Job Ad';
        });

        const selectedCombineSkillOptions = computed(() => {
            const skillsFromStore = Array.isArray(jobListingCreatePageData.job_skills)
                ? jobListingCreatePageData.job_skills
                : [];
            const selectedIds = new Set([
                ...searchSkillOptions.value.map((skill) => skill?.value ?? skill),
                ...selectedPopularSkills.value.map((skill) => skill?.value ?? skill),
            ]);
            const remainingSkills = skillsFromStore.filter((skill) => {
                const skillId = skill?.value ?? skill?.id ?? skill;
                return skillId !== undefined && skillId !== null && !selectedIds.has(skillId);
            });
            return [...searchSkillOptions.value, ...selectedPopularSkills.value, ...remainingSkills];
        });

        const countryArray = computed(() => {
            const region = process.env.VUE_APP_REGION;
            if (region === 'US') return ['us'];
            if (region === 'AU') return ['au'];
            return []; // Default or empty if region is not recognized
        });

        const form = reactive({
            job_type: jobListingCreatePageData.job_type ? jobListingCreatePageData.job_type : null,
            job_title: jobListingCreatePageData.job_title ? jobListingCreatePageData.job_title : '',
            job_location: jobListingCreatePageData.job_location ? jobListingCreatePageData.job_location : {},
            job_category: jobListingCreatePageData.job_category ? jobListingCreatePageData.job_category : '',
            job_skills: jobListingCreatePageData.job_skills ? jobListingCreatePageData.job_skills : [],
            min_rate: jobListingCreatePageData.min_rate ? jobListingCreatePageData.min_rate : null,
            max_rate: jobListingCreatePageData.max_rate ? jobListingCreatePageData.max_rate : null,
            rate_type: jobListingCreatePageData.rate_type ? jobListingCreatePageData.rate_type : 'hourly', // Added rateType property
            bonus: jobListingCreatePageData.bonus ? jobListingCreatePageData.bonus : 'No',
            platform_role_id: jobListingCreatePageData.platform_role_id ? jobListingCreatePageData.platform_role_id : null,
            hide_salary: jobListingCreatePageData.hide_salary ? jobListingCreatePageData.hide_salary : false,
            
        });

        const searchSkillOptions = ref([]);
        const searchQueryoptions = ref([]);
        const loading = ref(false);

        const selectedPopularSkills = ref([]);
        let popularSkillsOptions = ref([]);

        const jobTypeOptions = ref([]);
        const jobLocations = ref([])

        let getCategories = ref([]);

        let selectedCategories = ref([]);
        const selectedOption = ref(null);
        const dialogVisible = ref(false);
        const platformRoles = ref([]);

        const rules = computed(() => {
            return {
                job_type: {
                    required: helpers.withMessage('Please select job type', required),
                },
                job_title: {
                    required: helpers.withMessage('Please enter job title', required),
                    maxLength: helpers.withMessage('Job title must not be greater than 255 character', maxLength(255))
                },
                job_location: {
                    containsFormattedAddress: helpers.withMessage('Please select job location', value => {
                        return value && (value.formatted_address || value.locality || value.latitude) ? true : false;
                    }),
                    required: helpers.withMessage('Please select job location', required),
                },
                job_category: {
                    required: helpers.withMessage('Please select job category', required),
                },
                min_rate: {
                    required: helpers.withMessage('Please enter the valid min rate', required),
                    // Checks if the input is numeric with optional decimals
                    numeric: helpers.withMessage(
                        'Invalid number format',
                        (value) => /^\d*(\.\d*)?$/.test(value)
                    ),
                    // Conditional validator for max digits before the decimal, with dynamic message
                    maxDigitsBeforeDecimal: helpers.withMessage(
                        () =>
                            form.rate_type === 'annual'
                                ? 'Only up to 7 digits are allowed before the decimal'
                                : 'Only up to 3 digits are allowed before the decimal',
                        (value) => {
                            const maxDigits = form.rate_type === 'annual' ? 7 : 3;
                            const regex = new RegExp(`^\\d{1,${maxDigits}}(\\.\\d*)?$`);
                            return regex.test(value);
                        }
                    ),
                    // New validator to ensure there’s a digit after the decimal if a decimal is present
                    // decimalRequiresFraction: helpers.withMessage(
                    //     'If using a decimal, please enter at least one digit after the decimal',
                    //     (value) => !value.includes('.') || /\.\d+/.test(value) // Pass if no decimal or if there's at least one digit after the decimal
                    // ),
                    // Validator to ensure max 2 digits after the decimal
                    maxTwoDigitsAfterDecimal: helpers.withMessage(
                        'Only up to 2 decimal places are allowed',
                        (value) => /^\d*(\.\d{1,2})?$/.test(value)
                    ),
                    lessThanMax: helpers.withMessage('Minimum pay rate must be less than maximum pay rate', value => parseFloat(value) < parseFloat(form.max_rate))
                },
                max_rate: {
                    required: helpers.withMessage('Please enter the valid max rate', required),
                    // Checks if the input is numeric with optional decimals
                    numeric: helpers.withMessage(
                        'Invalid number format',
                        (value) => /^\d*(\.\d*)?$/.test(value)
                    ),
                    // Conditional validator for max digits before the decimal, with dynamic message
                    maxDigitsBeforeDecimal: helpers.withMessage(
                        () =>
                            form.rate_type === 'annual'
                                ? 'Only up to 7 digits are allowed before the decimal'
                                : 'Only up to 3 digits are allowed before the decimal',
                        (value) => {
                            const maxDigits = form.rate_type === 'annual' ? 7 : 3;
                            const regex = new RegExp(`^\\d{1,${maxDigits}}(\\.\\d*)?$`);
                            return regex.test(value);
                        }
                    ),
                    // New validator to ensure there’s a digit after the decimal if a decimal is present
                    // decimalRequiresFraction: helpers.withMessage(
                    //     'If using a decimal, please enter at least one digit after the decimal',
                    //     (value) => !value.includes('.') || /\.\d+/.test(value) // Pass if no decimal or if there's at least one digit after the decimal
                    // ),
                    // Validator to ensure max 2 digits after the decimal
                    maxTwoDigitsAfterDecimal: helpers.withMessage(
                        'Only up to 2 decimal places are allowed',
                        (value) => /^\d*(\.\d{1,2})?$/.test(value)
                    ),
                    greaterThanMin: helpers.withMessage('Maximum pay rate must be greater than minimum pay rate', value => parseFloat(value) > parseFloat(form.min_rate))
                },
            };
        });

        const v$ = useVuelidate(rules, form);
        const validateField = (fieldName) => {
            v$.value[fieldName].$touch();
            if (fieldName === 'max_rate' || fieldName === 'min_rate') {

                let value = event.target.value;
                const regex = /^\d{0,8}(\.\d{0,2})?$/;

                // Check if value matches the format
                if (!regex.test(value)) {
                    // If it doesn't, limit the input to a valid format
                    value = value.replace(/^(\d{0,8})(\.\d{0,2})?.*$/, '$1$2');
                }

                // Update the field's value with the validated format
                form[fieldName] = value;
            }
        };

        const showDialog = (event) => {
            event.preventDefault();
            dialogVisible.value = true;
        };

        const handleSelectionChange = (value) => {
            selectedOption.value = getCategories.value.find(option => option.value === value);
            console.log("🚀 ~ handleSelectionChange ~ selectedOption:", selectedOption)

        };

        const handleBeforeClose = (done) => {
            if (selectedOption.value) {
                selectCategory();
            }
            done();
        };

        const selectCategory = () => {
            if (!selectedCategories.value.includes(selectedOption.value)) {
                selectedCategories.value = selectedCategories.value.slice(0, 3);
                selectedCategories.value.push(selectedOption.value);
            }
            dialogVisible.value = false;
        };

        const fetchSkills = async (query) => {
            if (!query) {
                return;
            }
            loading.value = true;
            try {
                // Dispatch an action to fetch data from your API using Vuex store
                const response = await $store.dispatch("GET_SKILLS", {
                    'search': query
                });
                console.log("🚀 ~ fetchSkills ~ response:", response)
                // Assuming response.data contains the options you want to display
                searchQueryoptions.value = response.data
                    .map(skill => ({ label: skill.name, value: skill.id }));
            } catch (error) {
                console.error('Error fetching options:', error);
            } finally {
                loading.value = false;
            }
        };

        // Watch for changes in selectedCombineSkillOptions
        watch(selectedCombineSkillOptions, (newValue) => {
            // Update job_skills in the form object
            form.job_skills = newValue.map(option => option);

        });

        const setRateType = (type) => {
            form.rate_type = type;
            // validateField('rate'); // Trigger validation when rate type changes
        };

        const setAddressData = (addressData) => {
            // if addressData is a string, parse it to JSON
            if (typeof addressData === 'string') {
                addressData = JSON.parse(addressData);
            }
            form.job_location = addressData;
            jobLocationText.value = addressData.formatted_address;

            addressComponent.value += 1;
            validateField('job_location');
        };

        // Function to remove selected skill
        const removeSelectedSkill = (skill) => {
            const index1 = searchSkillOptions.value.findIndex(item => item.value === skill.value);
            if (index1 !== -1) {
                searchSkillOptions.value.splice(index1, 1);
            }

            const index2 = selectedPopularSkills.value.findIndex(item => item.value === skill.value);
            if (index2 !== -1) {
                selectedPopularSkills.value.splice(index2, 1);
            }

            const skillStoreIndex = jobListingCreatePageData.job_skills.findIndex(item => item.value === skill.value);
            if (skillStoreIndex !== -1) {
                jobListingCreatePageData.job_skills.splice(skillStoreIndex, 1);
            }
        };
        const isSubmitDisabled = computed(() => {
            return Object.values(form).some(value => value === '' || value === null) || v$.value.$pending || v$.value.$error || v$.value.$invalid;
        });

        const goNext = async () => {
            const result = await v$.value.$validate()

            console.log('🚀 ~ form ~ formmmmm', form);


            if (!result) {
                alert('The form has errors')
                return
            } else {

                console.log("🚀 ~ goNext ~ result:", form)
                const formData = {
                    job_type: form.job_type,
                    job_title: form.job_title,
                    job_location: extractLocationData(form.job_location),
                    job_category: form.job_category,
                    job_skills: form.job_skills,
                    min_rate: form.min_rate,
                    max_rate: form.max_rate,
                    rate_type: form.rate_type,
                    bonus: form.bonus,
                    platform_role_id: form.platform_role_id,
                    hide_salary: form.hide_salary,
                };
                $store.dispatch("setJobListingCreatePageData", formData);
                $router.push({
                    name: 'job_description_listing',
                });
            }

        };

        function extractLocationData(location) {
            if (!location) return null;
            return {
                administrative_area_level_1: location.administrative_area_level_1,
                administrative_area_level_2: location.administrative_area_level_2,
                country: location.country,
                formatted_address: location.formatted_address,
                latitude: location.latitude,
                longitude: location.longitude,
                locality: location.locality,
                postal_code: location.postal_code,
            };
        }

        const goBack = () => {
            $store.dispatch("clearJobListingCreatePageData");
            if(instance?.appContext.config.globalProperties.$filters.employerType(user).isCommunityPharmacy){
                if(backPage === '/create/option'){

                    $router.push({
                        name: 'create_option'
                    })
                }else{
                    $router.push({
                        name: 'search'
                    })
                }
            }else{
                $router.push({
                        name: 'job_poster'
                    })
            }
           
        };

        onMounted(() => {
            setPageClassGlobal('job_poster_create_job_lisitng');
            // setAddressData();
            if (form.job_location !== '' && jobListingCreatePageData.job_location) {
                setAddressData(jobListingCreatePageData.job_location);
            }

           

        });

        onBeforeMount(async () => {
            return new Promise((resolve) => {
                $store
                    .dispatch("GET_JOB_POSTER_LISTINGS")
                    .then((response) => {
                        let FetchResult = response.data;
                        FetchResult.popularSkills.forEach(skill => {
                            popularSkillsOptions.value.push({ label: skill.name, value: skill.id });
                        });

                        FetchResult.type.forEach(type => {
                            jobTypeOptions.value.push({ label: type.title, value: type.id });
                        });

                        FetchResult.location.forEach(location => {
                            jobLocations.value.push({ label: location.name, value: location.id });
                        });

                        FetchResult.category.forEach(item => {
                            getCategories.value.push({ label: item.title, value: item.id });
                        });

                        FetchResult.platformRoles.forEach(item => {
                            platformRoles.value.push({ label: item.name, value: item.id });
                        });

                        selectedCategories.value = getCategories.value.slice(0, 3);

                        
                        if (form.job_location !== '' && jobListingCreatePageData.job_category) {
                            // selectedCategories.value.push(jobListingCreatePageData.job_category);
                            selectedOption.value = getCategories.value.find(option => option.value === jobListingCreatePageData.job_category);
                            selectedCategories.value = selectedCategories.value.slice(0, 3);
                            selectedCategories.value.push(selectedOption.value);
                        }

                        if (Array.isArray(jobListingCreatePageData.job_skills) && jobListingCreatePageData.job_skills.length > 0) {
                            const existingSkills = jobListingCreatePageData.job_skills;
                            const knownIds = new Set(popularSkillsOptions.value.map((option) => option.value));
                            existingSkills.forEach((skill) => {
                                const skillId = skill?.value ?? skill?.id ?? skill;
                                if (skillId === undefined || skillId === null || knownIds.has(skillId)) {
                                    return;
                                }
                                popularSkillsOptions.value.push({
                                    label: skill.label || skill.name || String(skillId),
                                    value: skillId,
                                });
                                knownIds.add(skillId);
                            });
                            selectedPopularSkills.value = popularSkillsOptions.value.filter((option) =>
                                existingSkills.some((skill) => (skill?.value ?? skill?.id ?? skill) === option.value)
                            );
                        }
                        form.job_type = !form.job_type ? jobTypeOptions.value[0].value : form.job_type;
                        form.job_category = !form.job_category ? getCategories.value[0].value : form.job_category;
                        form.platform_role_id = !form.platform_role_id ? platformRoles.value[0].value : form.platform_role_id;
                        form.hide_salary = !form.hide_salary ? false : form.hide_salary;
                        resolve(response);
                    });
                            
            });
        });



        return {
            goBack,
            goNext,
            isSubmitDisabled,
            rules,
            form,
            jobTypeOptions,
            validateField,
            v$,
            jobLocations,
            getCategories,
            selectedCategories,
            dialogVisible,
            showDialog,
            selectCategory,
            handleSelectionChange,
            searchSkillOptions,
            searchQueryoptions,
            loading,
            fetchSkills,
            selectedPopularSkills,
            popularSkillsOptions,
            selectedCombineSkillOptions,
            removeSelectedSkill,
            setRateType,
            isAustralia,
            countryArray,
            setAddressData,
            jobLocationText,
            addressComponent,
            platformRoles,
            handleBeforeClose,
            instance,
            backPage,
            extractLocationData,
            pageTitle
        }
    },
}
</script>